import MicroModal from 'micromodal';
import { lenis } from './Scroll';

// ============================================
// ヘッダー追従
// ============================================
function fixedHeader() {
  const header = document.querySelector('.js-header');
  const hero = document.querySelector('.js-hero');
  if (!header || !hero) return;

  let headerHeight = header.clientHeight;
  let heroHeight = hero.clientHeight;
  let ticking = false;
  let resizeTimer = 0;

  const recalcSizes = () => {
    headerHeight = header.clientHeight;
    heroHeight = hero.clientHeight;
  };

  const applyState = () => {
    const scrollY = window.scrollY;
    if (scrollY > heroHeight) {
      header.classList.add('is-active');
      header.classList.remove('is-hidden');
      return;
    }

    header.classList.remove('is-active');
    if (scrollY > headerHeight) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      applyState();
    });
  };

  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      recalcSizes();
      applyState();
    }, 150);
  };

  recalcSizes();
  applyState();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
}

// ============================================
// drawer ハンバーガー開閉処理
// ============================================
function drawer() {
  MicroModal.init();

  const header = document.querySelector('.js-header');
  const hamburger = document.querySelector('.js-drawer-hamburger');
  const navigation = document.querySelector('.js-drawer-navigation');
  if (!hamburger || !navigation) return;

  const menuWrap = navigation.querySelector('.l-drawer__nav');
  const docStyle = getComputedStyle(document.documentElement);
  const wideHamburger = docStyle.getPropertyValue('--wide-hamburger').trim();
  const hamburgerBreakPoint = docStyle.getPropertyValue('--hamburger-breakpoint').trim();
  const mediaQuery = hamburgerBreakPoint ? window.matchMedia(`(max-width: ${hamburgerBreakPoint})`) : null;

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  let scrollGuardsEnabled = false;
  const addScrollGuards = () => {
    if (!menuWrap || scrollGuardsEnabled) return;
    scrollGuardsEnabled = true;
    menuWrap.addEventListener('wheel', stopPropagation, { passive: false });
    menuWrap.addEventListener('touchmove', stopPropagation, { passive: false });
  };

  const removeScrollGuards = () => {
    if (!menuWrap || !scrollGuardsEnabled) return;
    scrollGuardsEnabled = false;
    menuWrap.removeEventListener('wheel', stopPropagation);
    menuWrap.removeEventListener('touchmove', stopPropagation);
  };

  const setAriaHidden = (hidden) => {
    navigation.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  };

  const closeDrawer = (invokeModalClose = true) => {
    const wasOpen = navigation.getAttribute('aria-hidden') === 'false';
    setAriaHidden(true);
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    header?.classList.remove('is-open');
    lenis.start();
    if (invokeModalClose && wasOpen) {
      MicroModal.close('navigation');
    }
  };

  const openDrawer = () => {
    setAriaHidden(false);
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    header?.classList.add('is-open');
    lenis.stop();
    MicroModal.show('navigation', {
      onClose: () => {
        closeDrawer(false);
      },
    });
  };

  const hamburgerClick = () => {
    const isOpen = navigation.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  let hamburgerEnabled = false;
  const enableHamburger = () => {
    if (hamburgerEnabled) return;
    hamburgerEnabled = true;
    hamburger.addEventListener('click', hamburgerClick);
    addScrollGuards();
  };

  const disableHamburger = () => {
    if (!hamburgerEnabled) return;
    hamburgerEnabled = false;
    hamburger.removeEventListener('click', hamburgerClick);
    removeScrollGuards();
    closeDrawer();
    navigation.querySelectorAll('a, button').forEach((el) => {
      el.blur();
    });
  };

  navigation.setAttribute('aria-hidden', 'true');
  hamburger.setAttribute('aria-expanded', 'false');

  if (wideHamburger === 'false' && mediaQuery) {
    const applyMode = (mq) => {
      if (mq.matches) {
        enableHamburger();
      } else {
        disableHamburger();
      }
    };

    applyMode(mediaQuery);
    mediaQuery.addEventListener('change', applyMode);
  } else {
    enableHamburger();
  }

  navigation.querySelectorAll('.l-drawer__link').forEach((link) => {
    link.addEventListener('click', () => {
      if (navigation.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  });
}

// ============================================
// ヘッダーナビの文字分割
// ============================================
function navSplit() {
  const targets = document.querySelectorAll('.js-split');
  if (!targets.length) return;

  targets.forEach((target) => {
    const span = target.querySelector('span');
    if (!span) return;

    const text = span.textContent.trim();
    span.textContent = '';

    [...text].forEach((char) => {
      const letter = document.createElement('span');
      letter.textContent = char === ' ' ? '&nbsp' : char;
      span.append(letter);
    });

    const copySpan = span.cloneNode(true);
    target.appendChild(copySpan);
  });
}

export { fixedHeader, drawer, navSplit };
